export function authHeader() {
  const user = JSON.parse(localStorage.getItem("trademark-membership-user"));

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}

export function customerUid() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  return userInfo && userInfo.uid;
}
